import * as React from "react";
import FormButton from "../FormButton/FormButton";

interface IProps {
    options: any[];
    isDisabled: boolean;
}

export default class FormSelectButtons  extends React.Component<
    IProps
    > {

    public renderButtons = () => {
        return this.props.options.map((option, index) => {
            return <FormButton key={index} btnText={option.label} classes={"blank"   + (option.isSelected && !this.props.isDisabled ? " selected" : "")} click={!this.props.isDisabled && option.click}/>
        });
    };

    public render() {
        return (<>{this.renderButtons()}</>);
    }

}




// WEBPACK FOOTER //
// ./src/components/FormSelectButtons/FormSelectButtons.tsx